import { lazy } from "react"

export const InspectionsRoutes = [
  {
    path: "/inspections/:id/view-report",
    component: lazy(() => import("../views/inspection-report")),
    meta: {
      action: "call",
      resource: "INS_VIEW_INSPECTION_REPORT"
    }
  },
  {
    path: "/inspection/public/:id",
    exact: true,
    layout: 'BlankLayout',
    component: lazy(() => import("../views/public-inspection-report")),
    meta: {
      publicRoute: true
    }
  },
  {
    path: "/inspections",
    component: lazy(() => import("../views/inspections-list")),
    exact: true,
    meta: {
      action: "call",
      resource: "INS_VIEW_INSPECTION_LIST"
    }
  },
  {
    path: '/inspections/archive',
    component: lazy(() => import('../views/inspections-archive-list')),
    exact: true,
    meta: {
      action: 'call',
      resource: "INS_VIEW_ARCHIVED_INSPECTIONS|INS_MANAGE_INSPECTIONS"
    }
  }
]
